module.exports = __webpack_public_path__ + "img/whiteplus.b8027f5d.svg";